import { DocTypeConstants } from '../../constants/doc-types';
import { SyncGatewayInterfaces } from '../sync-gateway/sync-gateway.interfaces';
import { User } from './user';

export class FacilityAdminUser extends User {
  constructor(
    data: {
      account_id?: string;
      email?: string;
      facility_ids?: string[];
      first_name?: string;
      has_temporary_pin?: boolean;
      last_name?: string;
      created_by?: string;
      created_date?: string;
      media?: {
        [key: string]: {
          content_type: string;
          etag: string;
          s3_key: string;
          status: string;
        };
      };
      pin?: string;
      phone?: string;
      status?: string;
      title?: string;
      apollo_id?: number;
      apollo_import?: boolean;
      _id?: string;
      _rev?: string;
      _attachments?: { [key: string]: SyncGatewayInterfaces.IAttachment };
    } = {}
  ) {
    super({
      account_id: data.account_id,
      doc_type: DocTypeConstants.TYPES.USER.FACILITY_ADMIN,
      email: data.email,
      facility_ids: data.facility_ids,
      first_name: data.first_name,
      has_temporary_pin: data.has_temporary_pin,
      last_name: data.last_name,
      created_by: data.created_by,
      created_date: data.created_date,
      media: data.media,
      phone: data.phone,
      pin: data.pin,
      title: data.title,
      status: data.status,

      apollo_id: data.apollo_id,
      apollo_import: data.apollo_import,

      _id: data._id,
      _rev: data._rev,
      _attachments: data._attachments,
    });
  }
}
